import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client/core';
import { setContext } from '@apollo/client/link/context'

const httpLink = createHttpLink({
  uri: process.env.VUE_APP_GRAPHQL_API || 'https://graph.salescloud.is',
});

const authLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
      'salescloud-system': 'checkout',
      'Content-Type': 'application/json',
    },
  };
});

const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});

export default apolloClient;
